import { isArray, isString } from 'lodash';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';

export const useCallCallback = ({ callbackKey, callbackOptions, customCallbacks }) => {
  const generalCallbacks = useApplicationCallbacks();

  const totalCallbacks = { ...generalCallbacks, ...(customCallbacks ?? {}) };

  return {
    callCallback() {
      const callbackType = isString(callbackKey) ? 'string' : isArray(callbackKey) && 'array';

      ({
        string() {
          totalCallbacks[callbackKey]?.(callbackOptions);
        },
        array() {
          callbackKey.forEach((key) => {
            const props = (callbackOptions ?? {})[key];
            totalCallbacks[key]?.(props);
          });
        },
      })[callbackType]?.();
    },
  };
};
